import React from "react";
import axios from "axios";
import { useQuery } from "react-query";
import { Button } from "components/buttonV2";
import { useModalContext } from "components/modal";
import SpecialReportModal from "./SpecialReportModal";

type Props = {
  viewedEmployeeId: number | string;
};

const SpecialReport = ({ viewedEmployeeId }: Props) => {
  const { setModal } = useModalContext();

  const { data: currentUser } = useQuery(
    ["current-user"],
    async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/users/current-user`
      );
      return response.data;
    },
    { retry: false }
  );

  // This component is rendered inside the admin employee area already.
  // We still require an authenticated current user before showing actions.
  if (!currentUser) {
    return null;
  }

  return (
    <div className="flex flex-row items-center">
      <Button
        type="secondary"
        onClick={() => {
          setModal({
            component: <SpecialReportModal viewedEmployeeId={viewedEmployeeId} />,
            label: "Special Report",
          });
        }}
      >
        Special Report
      </Button>
    </div>
  );
};

export default SpecialReport;
